import { render, staticRenderFns } from "./CreatePricingForWrapped.vue?vue&type=template&id=91f3027c&scoped=true"
import script from "./CreatePricingForWrapped.vue?vue&type=script&lang=js"
export * from "./CreatePricingForWrapped.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./CreatePricingForWrapped.vue?vue&type=style&index=1&id=91f3027c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91f3027c",
  null
  
)

export default component.exports